import type React from 'react';

export const sanitizeContentEditablePaste = (
	e: React.ClipboardEvent<HTMLElement>,
): void => {
	if (e.clipboardData?.files?.length) {
		e.preventDefault();
		return;
	}
	const text = e.clipboardData?.getData('text/plain') ?? '';
	e.preventDefault();
	document.execCommand('insertText', false, text);
};
